/**
 * Created by Carsten Hibbeler
 * Copyright: xdot GmbH 2016
 */

'use strict';

import React from 'external/react';
import StateValueActions from '../actions/StateValueActions';
import StateValueLabel from '../components/StateValueLabel';
import PropTypes from 'external/prop-types';
import { translation } from 'plugin/liferay-widgets-react-web';
import { DateTimeDisplay } from 'plugin/base-portlet';

class FliwasListItemStatus extends React.Component {

    constructor(props) {
        super(props);

        this.onClickDetailsBox = this.onClickDetailsBox.bind(this);
    }

    onClickDetailsBox() {
        StateValueActions.openStatusHistory(this.props.stateValue);
    }

    getTranslation(activeState) {
        let title = translation.trans((activeState.className ? (activeState.className + '.') : '') + activeState.propName);

        if (activeState.className === 'ManualBooleanState') {
            title = 'Ereigniszustand';
        }
        return title;
    }

    render() {

        const { stateValue } = this.props;

        if (!stateValue) {
            return null;
        }

        const title = this.getTranslation(stateValue);
        return (
            <div className="list-item-state-wrapper">
                <span className="list-item-status" onClick={this.onClickDetailsBox}>
                        <StateValueLabel stateName={title && title} item={stateValue}/>
                </span>
                <DateTimeDisplay timestamp={stateValue.timestamp} classNames="date"/>
            </div>
        );
    }
}

FliwasListItemStatus.propTypes = {
    stateValue: PropTypes.object.isRequired,
};

export default FliwasListItemStatus;



// WEBPACK FOOTER //
// ./js/components/FliwasListItemStatus.jsx